import type { Subscription } from '../../types';
import { isModernEnterprisePlan } from '../modernSubscription/isModernEnterprisePlan';

import { isModernSubscription } from './isModernSubscription';

export function isEnterprisePlan(subscription: Subscription): boolean {
  if (isModernSubscription(subscription)) {
    return isModernEnterprisePlan(subscription);
  }
  return false;
}
